<template>
  <button
    id="burger"
    class="navbar-toggler burger order-1"
    type="button"
    data-toggle="collapse"
    data-target=".multi-collapse"
    aria-controls="turbo menu_left menu_right"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <font-awesome-icon :icon="['fas', 'bars']" />
  </button>
</template>

<script>
export default {
  name: "fcwpToggler"
};
</script>

<style scoped lang="scss">
.burger {
  display: none;
  position: absolute;
  top: 30px;
  left: 30px;
  background-color: transparent;
  z-index: 1500;
  font-size: 16pt;
  color: rgb($quinary-color);
  border: 2px solid rgb($quinary-color);
  padding: 5px 10px 5px 10px;
  border-radius: 0.15em;
}
.burger:hover {
  color: rgb($secondary-color);
  border-color: rgb($secondary-color);
  text-shadow: none;
}

.jumbotron-image .burger,
.jumbotron-video .burger {
  color: rgb($quaternary-color);
  border: 2px solid rgb($quaternary-color);
  text-shadow: 0px 0px 1px rgba(48, 62, 71, 1);
  -webkit-box-shadow: inset 0px 0px 2px rgba(48, 62, 71, 0.6);
  -moz-box-shadow: inset 0px 0px 2px rgba(48, 62, 71, 0.6);
  box-shadow: inset 0px 0px 2px rgba(48, 62, 71, 0.6),
    0px 0px 2px 0px rgba(48, 62, 71, 0.6);
  :hover {
    color: rgb($secondary-color);
    border-color: rgb($secondary-color);
    text-shadow: none;
  }
}

.jumbotron-image .burger:hover,
.jumbotron-video .burger:hover {
  border-color: rgb($secondary-color);
}

@media (max-width: 1200px) {
  .burger {
    display: block;
    
  }
}


@media (max-width: 700px) {
  .burger {
    position: static;
    margin: 20px 0 0 20px;
    // top: 120px;
    // left: 20px;
  }
}

// @media (max-width: 290px) {
//   .burger {
//     top: calc(35vw + 20px);
//     left: 10px;
//   }
// }

</style>